import {HttpClient} from '@angular/common/http';
import {StorageService} from "../services/storage.service";
import {isPlatformBrowser} from "@angular/common";
import {TranslateHttpLoader} from "./translate-http-loader";
import {TranslateService} from "@ngx-translate/core";
import {LanguageService} from "../services/language.service";
import {ValidatorConfigService} from "../services/validator-config.service";
import {TranslatedMetaService} from "../services/translated-meta.service";
import {PrimeNGConfig} from "primeng/api";
import {firstValueFrom} from "rxjs";
import { InjectionToken } from '@angular/core';
import type { Request, Response } from 'express';
import {CacheStoreService} from "../services/cache-store.service";
import {NetworkStatusService} from "../services/network-status.service";
import {MediaOfflineService} from "../services/media-offline.service";
import {MobileExperienceConfigService} from '../mobile/mobile-experience-config.service';
import {NativeSecureSessionService} from '../mobile/native-secure-session.service';

export const REQUEST = new InjectionToken<Request>('REQUEST');
export const RESPONSE = new InjectionToken<Response>('RESPONSE');

export function jwtOptionsFactory(storageService: StorageService, platformId: object) {
  return {
    tokenGetter: () => {
      if (isPlatformBrowser(platformId)) {
        let token = storageService.getItem('token');
        storageService.watchStorage().subscribe((data: any) => {
          if (data.hasOwnProperty('token')) {
            token = data.token;
          }
        });
        return token;
      }
      return null;
    },
    whitelistedDomains: [],
    skipWhenExpired: true
  };
}

export function HttpLoaderFactory(http: HttpClient, platformId: object) {
  return new TranslateHttpLoader(http, platformId);
}

export function appInitializerFactory(
  translate: TranslateService,
  languageService: LanguageService,
  validatorConfigService: ValidatorConfigService,
  tms: TranslatedMetaService,
  config: PrimeNGConfig,
  cacheStore: CacheStoreService,
  networkStatus: NetworkStatusService,
  mediaOffline: MediaOfflineService,
  mobileExperienceConfig: MobileExperienceConfigService,
  nativeSecureSession: NativeSecureSessionService,
) {
 return async () => {
   await nativeSecureSession.initialize();
   await networkStatus.init();
   await mediaOffline.init();
   const lang = languageService.getLanguage();
   translate.setDefaultLang(lang);
   await firstValueFrom(translate.use(lang));
   validatorConfigService.loadValidationMessages();
   tms.updateMetaTag('description');
   tms.updateMetaTag('keywords');
   translate.get('primeng').subscribe(res => config.setTranslation(res));
   await cacheStore.init();
   await mobileExperienceConfig.initializeForBootstrap();
 };
}
